import { gql } from '../types/generated';

export const GET_PIPELINE_CONFIGS = gql(`
  query getPipelineConfigs {
    pipelineConfigs {
      ...PipelineConfigFields
    }
  }
`);
